import { readLocalValue, writeLocalValue } from "~/utils/localStorageValue";

const SIGN_UP_EVENT_MARK_KEY_PREFIX = "ph_sign_up_event_sent_";
const SIGN_UP_EVENT_MARK_VALUE = "1";

const toMarkKey = (userId: string): string =>
  `${SIGN_UP_EVENT_MARK_KEY_PREFIX}${userId}`;

export const hasSentSignUpEvent = (userId: string): boolean =>
  readLocalValue(toMarkKey(userId)) !== null;

export const markSignUpEventSent = (userId: string): void =>
  writeLocalValue(toMarkKey(userId), SIGN_UP_EVENT_MARK_VALUE);
